import React, { createRef, forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import Swal from 'sweetalert2';
import API from '../../API';
import moment from 'moment';
import { createRoot } from 'react-dom/client';
import { DateThaiFormat, NumberFormat,DateFormatJSON} from '../../Utils/Function';
import parse from 'html-react-parser'
import { Controller, useForm } from "react-hook-form";
import ThaiDatePicker from '../ThaiDatePicker';
import {DataTable} from '../'

const TopupCard = forwardRef((props, ref) => {
    const { register, handleSubmit, watch, reset, getValues, setValue, control, formState: { errors } } = useForm();
    const[_MemberID,setMemberID] = useState(null);
    const [_StartDate, setStartDate] = useState(moment().add(-7,'day').toDate());
    const [_EndDate, setEndDate] = useState(new Date());
    const _ref = useRef();
    useEffect(() => {
        (async () => {
            setValue('Start',moment().add(-7,'day').toDate());
            setValue('End',new Date())
        })();

        return () => { }
    }, []);

    useImperativeHandle(ref, () => ({
         Show(MemberID){
            setMemberID(MemberID);
            setValue('MemberID',MemberID);
            setTimeout(()=>{
                ref.current?.load();
            },500);
        },
    }));


const _configs = {
        "order": [[0, "desc"]],
        pageLength: 10,
        orderMulti: true
    }
    
    const _ajax  = {
        'url': '/Topup/List',
        'method': 'POST',
        'caches': false,
        'global': false,
        'data': function (d) {
            d.MemberID = props.MemberID;
            d.StartDate = DateFormatJSON(getValues('Start'),false);
            d.EndDate = DateFormatJSON(getValues('End'),false);
        }
    };

    const _Buttons = (d,r) => (
        <div className='btn-group btn-group-sm'>
        </div>
    )
    const _column = [
       {data: "Created", name: "Created", autoWidth: true,render(data){
            return DateThaiFormat(data,true);
        }},
        { data: "Amount", name: "Amount", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "AfterCredit", name: "AfterCredit", autoWidth: true,render(data){
            return NumberFormat(data);
        } },
        { data: "Status", name: "Status", autoWidth: true,render(data){
            switch(data){
                case 1 : return '<label class="text-success">เติมเงิน</label>';
                case 2 : return '<label class="text-danger">ยกเลิก</label>';
                default : return '-';
            };
        } },
        { data: "ReasonName", name: "ReasonName", autoWidth: true },
        {
            data: "TransactionID", name: "TransactionID", autoWidth: true,
            render: (data) => { return ''; },
            createdCell: (td, cellData,rowData) => createRoot(td).render(_Buttons(cellData,rowData))
        }
    ]
    const _ColumnDefs = [
    ]
    
    return (
        <>
        <div className='row justify-content-end'>
            <div className='col-2 text-end'>
                <ThaiDatePicker
                    className='form-control text-center'
                    selectsStart
                    selected={_StartDate}
                    onChange={(date) => { setStartDate(date); setValue('Start',date); _ref.current?.load(); }}
                    startDate={_StartDate}
                    endDate={_EndDate}
                    placeholderText="วันที่ เริ่มต้น"
                />
            </div>
            <div className='col-2 text-end'>
                <ThaiDatePicker
                    className='form-control text-center'
                    selectsEnd
                    selected={_EndDate}
                    onChange={(date) => { setEndDate(date); setValue('End',date); _ref.current?.load(); }}
                    startDate={_StartDate}
                    endDate={_EndDate}
                    minDate={_StartDate}
                    placeholderText="วันที่ สิ้นสุด"
                />
            </div>
        </div>
        <div className='row'>
           <div className="col-lg-12 table-responsive">
                <table id="TopupTableView" className='table w-100' role='grid'>
                    <thead>
                        <tr>
                        <th className="text-center textcenter">วันที่ / เวลา</th>
                        <th className="text-center textcenter">ยอดเงิน</th>
                        <th className="text-center textcenter no-sortr">ยอดเงินคงเหลือ</th>
                        <th className="text-center textcenter no-sortr">สถานะ</th>
                        <th className="text-center textcenter no-sort">หมายเหตุ</th>
                        <th className="text-center no-sort"></th>
                        </tr>
                    </thead>
                    <DataTable TableID={"TopupTableView"} Column={_column} Configs={_configs} ref={_ref} ajax={_ajax} ColumnDefs={_ColumnDefs} />
                </table>
            </div>
        </div>
        </>
    );

});

export default React.memo(TopupCard)